export default "__VITE_ASSET__DQBL32Y9__"